@if (showAddForm) {
  <div class="cd-card pt-add-card">
    <div class="cd-card-header">
      <h3>New Term</h3>
    </div>
    <form class="pt-form" (ngSubmit)="addTerm()">
      <div class="pt-form-row">
        <div class="pt-field">
          <label for="new-term">Term</label>
          <input
            id="new-term"
            type="text"
            [(ngModel)]="newTerm"
            name="newTerm"
            autocomplete="off"
            placeholder="e.g. badword"
            data-testid="new-term-input"
          />
        </div>
        <div class="pt-field">
          <label for="new-category">Category (optional)</label>
          <input
            id="new-category"
            type="text"
            [(ngModel)]="newCategory"
            name="newCategory"
            autocomplete="off"
            placeholder="e.g. profanity"
          />
        </div>
        <button
          type="submit"
          class="handle-btn-primary pt-btn-lg"
          [disabled]="saving"
          data-testid="submit-add-term"
        >
          {{ saving ? 'Adding…' : 'Add' }}
        </button>
      </div>
      @if (addError) {
        <p class="pt-error" role="alert">{{ addError }}</p>
      }
    </form>
  </div>
}

<div class="cd-card pt-filter-card">
  <input
    type="text"
    class="pt-search"
    [(ngModel)]="searchQuery"
    name="searchQuery"
    placeholder="Search terms or category…"
    aria-label="Search terms"
    (ngModelChange)="resetPage()"
  />
  <select
    class="pt-letter-select"
    [(ngModel)]="letterFilter"
    name="letterFilter"
    aria-label="Jump to letter"
    (ngModelChange)="resetPage()"
  >
    <option value="all">All letters</option>
    @for (letter of alphabet; track letter) {
      <option [value]="letter">{{ letter }}</option>
    }
    <option value="#">#</option>
  </select>
  <div class="pt-status-filters" role="group" aria-label="Status filter">
    <button
      class="pt-filter-btn"
      [class.pt-filter-active]="statusFilter === 'all'"
      (click)="statusFilter = 'all'; resetPage()"
    >
      All
    </button>
    <button
      class="pt-filter-btn"
      [class.pt-filter-active]="statusFilter === 'active'"
      (click)="statusFilter = 'active'; resetPage()"
    >
      Active
    </button>
    <button
      class="pt-filter-btn"
      [class.pt-filter-active]="statusFilter === 'inactive'"
      (click)="statusFilter = 'inactive'; resetPage()"
    >
      Inactive
    </button>
  </div>
</div>

@if (loading) {
  <p class="mod-loading">Loading terms...</p>
}

@if (error) {
  <p class="pt-error" role="alert">{{ error }}</p>
}

@if (!loading && !error) {
  <div class="cd-card pt-table-card">
    <div class="cd-card-header">
      <h3>Blocked Terms ({{ filteredTerms.length }})</h3>
      @if (totalPages > 1) {
        <div class="pt-pagination pt-pagination-top">
          <button
            class="pt-page-btn"
            (click)="prevPage()"
            [disabled]="currentPage === 1"
            aria-label="Previous page"
          >
            ← Prev
          </button>
          <span class="pt-page-info">Page {{ currentPage }} of {{ totalPages }}</span>
          <button
            class="pt-page-btn"
            (click)="nextPage()"
            [disabled]="currentPage === totalPages"
            aria-label="Next page"
          >
            Next →
          </button>
        </div>
      }
      <button
        class="handle-btn-primary pt-btn-lg"
        (click)="toggleAddForm()"
        data-testid="toggle-add-term"
      >
        {{ showAddForm ? 'Cancel' : '+ Add Term' }}
      </button>
    </div>

    @if (filteredTerms.length === 0) {
      <p class="mod-empty">No terms found.</p>
    }

    @if (filteredTerms.length > 0) {
      <table class="pt-table">
        <thead>
          <tr>
            <th>Term</th>
            <th>Category</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (term of pagedTerms; track term.id) {
            <tr>
              @if (editingId === term.id) {
                <td colspan="4">
                  <div class="pt-edit-row">
                    <input
                      type="text"
                      [(ngModel)]="editTerm"
                      name="editTerm"
                      class="pt-edit-input"
                      aria-label="Edit term"
                    />
                    <input
                      type="text"
                      [(ngModel)]="editCategory"
                      name="editCategory"
                      class="pt-edit-input"
                      placeholder="Category"
                      aria-label="Edit category"
                    />
                    <button class="handle-btn-primary pt-sm" (click)="saveEdit(term)">Save</button>
                    <button class="handle-btn-secondary pt-sm" (click)="cancelEdit()">
                      Cancel
                    </button>
                  </div>
                  @if (editError) {
                    <p class="pt-error" role="alert">{{ editError }}</p>
                  }
                </td>
              } @else {
                <td class="pt-term-cell">{{ term.term }}</td>
                <td>{{ term.category || '—' }}</td>
                <td>
                  <button
                    class="pt-status-badge"
                    [class.pt-status-active]="term.is_active"
                    [class.pt-status-inactive]="!term.is_active"
                    (click)="toggleActive(term)"
                    [attr.aria-label]="term.is_active ? 'Deactivate term' : 'Activate term'"
                  >
                    {{ term.is_active ? 'Active' : 'Inactive' }}
                  </button>
                </td>
                <td class="pt-actions-cell">
                  @if (confirmDeleteId === term.id) {
                    <span class="pt-confirm-delete">
                      Delete?
                      <button class="pt-link-btn pt-danger" (click)="deleteTerm(term)">Yes</button>
                      <button class="pt-link-btn" (click)="cancelDelete()">No</button>
                    </span>
                  } @else {
                    <button class="pt-link-btn" (click)="startEdit(term)" aria-label="Edit term">
                      Edit
                    </button>
                    <button
                      class="pt-link-btn pt-danger"
                      (click)="confirmDelete(term)"
                      aria-label="Delete term"
                    >
                      Delete
                    </button>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
      @if (totalPages > 1) {
        <div class="pt-pagination">
          <button
            class="pt-page-btn"
            (click)="prevPage()"
            [disabled]="currentPage === 1"
            aria-label="Previous page"
          >
            ← Prev
          </button>
          <span class="pt-page-info">Page {{ currentPage }} of {{ totalPages }}</span>
          <button
            class="pt-page-btn"
            (click)="nextPage()"
            [disabled]="currentPage === totalPages"
            aria-label="Next page"
          >
            Next →
          </button>
        </div>
      }
    }
  </div>
}
